<template>
  <div
    class="d-flex justify-content-between align-items-center px-12 fw-400 border-bottom"
    style="z-index: 2; width: 100%; height: 48px; background-color: white"
    v-if="data.isBlocked === 1"
    >
    <div class="text-normal me-2 d-flex">
      <img
        src="/assets/icon/icon_red_block.svg"
        width="16px" />
      <span class="ms-2 text-grey600">Bạn đã chặn người dùng này.</span>
    </div>
    <div>
      <el-button
        size="mini"
        @click="handleActionBlock('unblock')"
        type="info">
        <span class="fw-400 font-14">Bỏ chặn</span>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "conversation"],
  methods: {
    handleActionBlock(action) {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
        action: action,
        conversationId: this.conversation.id,
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.data.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.data.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
      });
    },
  },
};
</script>

<style>
</style>